import React from 'react'
import { Company } from 'models'
import { useCompanies } from 'contexts/CompaniesContext'

const useSingleSelectedCompany = () => {
  const { validatedSelectionState } = useCompanies()

  const hasSingleSelection = React.useMemo(
    () => validatedSelectionState.mode === 'single',
    [validatedSelectionState],
  )

  const selectedCompany: Company | null = hasSingleSelection
    ? validatedSelectionState.items[0]
    : null

  return { hasSingleSelection, selectedCompany }
}

export { useSingleSelectedCompany }
